// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"183":"279dff5f","475":"75e0bb07","971":"a612441b"}[chunkId] + ".js";
};